<div class="logo">
  @if (logo$ | async; as logo) {
    <img class="logo__image" [src]="logo?.url" [alt]="logo?.name" />
  } @else {
    <strong class="logo__fallback">{{ 'logo_fallback' | translate }}</strong>
  }
</div>
